import axios from 'axios';

const giphyTrendingUrl = 'https://api.giphy.com/v1/gifs/trending?api_key=alxVJ8CJhAUJawRFEro9YNM9KKnEAthy';
const giphySearchUrl = 'https://api.giphy.com/v1/gifs/search?api_key=alxVJ8CJhAUJawRFEro9YNM9KKnEAthy';

export const fetchTrendingGiphyGifs = () => axios.get(giphyTrendingUrl);

export const searchGiphyGifs = ({ searchValue, limit, rating = 'pg' }) =>
  axios.get(`${giphySearchUrl}&q=${searchValue.replace(' ', '+')}&limit=${limit}&rating=${rating}`);
